export default __webpack_public_path__ + "static/ogg-roman-11f0ab74c6627a4c447acab7f314a3bb.woff";